import { Tooltip } from '@vtex/admin-ui'
import { FormattedMessage, useIntl } from 'react-intl'
import { OPERATORS, type Affiliates as AffiliatesType } from 'typings'
import { Tag } from 'ui'
import { messages } from './messages'

type Props = {
  affiliates: NonNullable<AffiliatesType>
}

export function Affiliates(props: Props) {
  const { formatList, $t } = useIntl()
  if (!props.affiliates) return null
  const {
    affiliates: { operator, affiliates },
  } = props

  const processTooltip = () => {
    if (operator === OPERATORS.EQUALS) {
      return formatList(affiliates.map((af) => af.name) ?? [])
    }

    return $t(messages.affiliates.isDifferent, {
      affiliates: formatList(affiliates.map((af) => af.name) ?? []),
    })
  }

  return (
    <Tooltip text={processTooltip()}>
      <Tag>
        <FormattedMessage {...messages.affiliates.title} />
      </Tag>
    </Tooltip>
  )
}
